export default __webpack_public_path__ + "static/cup-ca288c7325a940d5ee8b85feb4fce668.png";